// extracted by mini-css-extract-plugin
export default {"userBadge":"userBadge__BvUt8","small":"small__PBaUf","medium":"medium__SYQLq","large":"large__vZ8Se","api":"api__Lf6o5","guest":"guest__eSASN","avatar":"avatar__lPOWy"};